import '@bjb/bjb-web-components/dist/components/jb-bypass-block/jb-bypass-block.js';

window.addEventListener('jb-bypass-block:navigate', (evt) => {
  (evt.target as HTMLElement)?.blur();
  document.dispatchEvent(
    new CustomEvent('jb-focus-fly:reset', { bubbles: true, composed: true })
  );

  if (evt.detail.name === 'navigation') {
    const navigation = document.querySelector('jb-navigation');
    (
      navigation?.shadowRoot?.querySelector('jb-burger-icon') as HTMLElement
    )?.click();
  }

  if (evt.detail.name === 'eservices') {
    const eservices = document.querySelector('jb-navigation');
    (
      eservices?.shadowRoot?.querySelector('jb-e-service-icon') as HTMLElement
    )?.click();
  }

  if (evt.detail.name === 'content') {
    const main = document.querySelector('main') ?? document.querySelector('#main');
    if (main) {
      const firstTextNode = findFirstTextNode(main.shadowRoot ?? main);
      const focusTarget = (firstTextNode?.parentElement ?? main) as HTMLElement;
      if (!focusTarget.hasAttribute('tabindex')) {
        focusTarget.setAttribute('tabindex', '-1');
      }
      focusTarget.focus();
    }
  }
});

function findFirstTextNode(root: Element | ShadowRoot): Text | null {
  for (const node of root.childNodes) {
    if (node.nodeType === Node.TEXT_NODE && (node as Text).data.trim()) {
      return node as Text;
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      const found = findFirstTextNode((node as Element).shadowRoot ?? (node as Element));
      if (found) return found;
    }
  }
  return null;
}
